import React from "react";
import { cn } from "utils";
import { IndicesItem } from "./IndicesItem";
import { IndicesListSkeleton } from "./IndicesListSkeleton";
import type { IndicesListProps } from "./type";
import { ROUTER_PATH } from "@/src/config";
import { HORIZONTAL_SCROLL_ATTR } from "@/src/hooks/useSwipeTabs";

/**
 * @description 指数|加密货币 卡片列表组件：只负责渲染 UI，数据获取与拼装逻辑由外部负责
 */
export const IndicesList: React.FC<IndicesListProps> = ({
  type,
  items,
  className,
}) => {
  // 当数据为空时显示骨架屏，保持布局稳定，避免路由切换时的抖动
  if (!items?.length) {
    return <IndicesListSkeleton className={className} />;
  }

  return (
    <div
      {...{ [HORIZONTAL_SCROLL_ATTR]: "true" }}
      className={cn(
        // 小屏：横向滚动
        "flex flex-row flex-nowrap gap-5 overflow-x-auto no-scrollbar px-4",
        // 大屏：2x2 网格布局
        "md:grid md:grid-cols-2 md:gap-3 md:px-0",
        className,
      )}
    >
      {items.map((item) => (
        <IndicesItem
          key={item.index}
          type={type}
          href={
            type === "crypto"
              ? `${ROUTER_PATH.CRYPTO_TOKEN}/${item.id}`
              : undefined
          }
          className="min-w-[96px] flex-1 md:flex-none md:min-w-0"
          {...item}
        />
      ))}
    </div>
  );
};
